// removed by extract-text-webpack-plugin
module.exports = {"input":"_1IjXpgLc","inputfile":"At3XDxto","upload-container":"_3nshfQQC","labelfile":"_1fV_Y1Th","description-container":"_2urV66zJ"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/FileUploadInput/FileUploadInput.styl
// module id = 504
// module chunks = 0